import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  ModalCard,
  ModalFooter,
  useCreateModal,
} from 'partial/components/Modal';
import Button from 'partial/components/Button';
import { useDeleteMaskName } from '../hooks';

export const useOpenDeleteMaskName = () => {
  const createModal = useCreateModal();

  const openDeleteMaskNameModal = useCallback(
    (data) => {
      createModal({
        content: (close) => <DeleteMaskName data={data} onClose={close} />,
      });
    },
    [createModal],
  );

  return openDeleteMaskNameModal;
};

function DeleteMaskName({ onClose, data }) {
  const [isLoading, remove] = useDeleteMaskName(onClose);

  const submit = () => {
    remove(data?.uuid);
  };

  return (
    <ModalCard size="sm" title="Remove this mask name?" onClose={onClose}>
      <div className="px-5 py-4 w-full">
        <p className="text-sm text-neutral-700">
          <span className="font-semibold text-neutral-900">{data?.name}</span>{' '}
          will be removed for{' '}
          <span className="font-semibold text-neutral-900">
            {data?.organization_name}
          </span>
          . Queued messages against it stop sending immediately.
        </p>
      </div>
      <ModalFooter>
        <Button secondary onClick={onClose}>
          Cancel
        </Button>
        <Button
          danger
          isLoading={isLoading}
          loadingLabel="Removing…"
          onClick={submit}
        >
          Remove mask name
        </Button>
      </ModalFooter>
    </ModalCard>
  );
}

DeleteMaskName.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DeleteMaskName;
